import { Component, OnInit, OnChanges, SimpleChanges,
  Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { diacriticless } from '../../../../@core/common/global';

export const nrkHrDummyId = '000000000000000000007358';

@Component({
  selector: 'ngx-doc-form-filter-select',
  templateUrl: './doc-form-filter-select.component.html',
  styleUrls: ['./doc-form-filter-select.component.scss'],
})
export class DocFormFilterSelectComponent implements OnInit, OnChanges {

  @Input() options: { id: string, name: string }[] = [];
  @Input() value: string;
  @Input() noClear: boolean = false;
  @Input() placeholder: string;
  @Input() noBorder: boolean = false;
  @Input() clearOnSelect: boolean = false;
  @Input() disabled: boolean = false;
  @Input() title: string = '';
  @Input() print: boolean = false;
  @Input() minWidth: number = 250;
  @Input() textable: false;
  @Input() separator: string = null;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('listItems') listItems: ElementRef;
  @ViewChild('textinput') textinput: ElementRef;
  @ViewChild('popup') popup: ElementRef;

  currentValue = '';
  textValue = '';
  selectedIndex = -1;
  popupWidth = 400;

  itemsCount = 0;
  itemHeight = 0;

  dummyId = nrkHrDummyId;

  displayOptions: { id: string, cols: string[] }[] = [];

  _showPopup = false;
  private preventDockClick = false;
  showPopup = (show = true, preventDocClick = false) => {
    this._showPopup = show;
    this.preventDockClick = preventDocClick;
  }

  constructor(
    private cdRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    if (this.textValue == null) {
      this.textValue = '';
    }
    if (this.value == null) {
      this.value = '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      this.options && this.options.forEach(opt => {
        if (opt) opt.name = (opt || '') && (opt.name || '').replace(/\n/g, ' ↵ ')
      })
      this.displayOptions = this.options && this.options.map(m => m && ({ id: m.id, cols: m.name.split('|') }));
      this.onTextChange();
    }
    if (changes.value) {
      if (changes.value.currentValue && changes.value.currentValue['_id']) {
        changes.value.currentValue = changes.value.currentValue['_id'];
      }
      this.value = changes.value.currentValue;
      this.onTextChange();
    }
  }

  onTextChange() {
    const sel = this.options && this.options.find && this.options.find(f => f && this.value === f.id);
    this.textValue = sel ? sel.name : '';
  }

  onClick(event) {
    if (this.disabled) return;
    this.showPopup(!this._showPopup);
    if (this._showPopup) {
      this.selectedIndex = 0;
      this.currentValue = ''; // this.textValue;
      this.selectedIndex = (this.options && this.options.map(m => m && m.id) || []).indexOf(this.value);
      const inputWidth = this.textinput && this.textinput.nativeElement.offsetWidth;
      this.popupWidth = inputWidth > this.minWidth ? inputWidth : this.minWidth;
      console.log('offsetWidth', inputWidth, this.popupWidth);
      setTimeout(() => { // TODO: event based (ngAfterViewChecked, IntersectionObserver)?
        this.adjustPopup();
      }, 50)
      event.stopPropagation();
    }
  }

  // onSelect(idx) {
  //   this.value = this.filter(this.currentValue)[idx].id;
  //   this.textValue = this.filter(this.currentValue)[idx]['cols'].join('');
  //   this.showPopup(false);
  //   this.valueChange.emit(this.filter(this.currentValue)[idx].id);
  //   if (this.clearOnSelect) this.clear();
  //   this.cdRef.detectChanges();
  // }

  // onDocClick(event) {
  //   if (this.popup == null) return;
  //   const er = this.popup.nativeElement.getBoundingClientRect();
  //   const tr = event.target.getBoundingClientRect();
  //   if (this.preventDockClick) {
  //     this.preventDockClick = false;
  //   } else if (tr.width !== 0 && tr.height !== 0 && !(er.left <= tr.left && tr.left <= er.left + er.width &&
  //     er.top <= tr.top && tr.top <= er.top + er.height)) {
  //     this.showPopup(false);

  //   }
  // }

  // onBlur(event) {
  //   if (!this._showPopup) return;
  //   const related = event.relatedTarget;
  //   if (related && this.popup && this.popup.nativeElement.contains(related)) return;
  //   this.showPopup(false);
  // }

  onSelect(event: MouseEvent | KeyboardEvent, idx: number) {
    // Prevent event from bubbling or losing input focus prematurely
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const filtered = this.filter(this.currentValue);
    if (!filtered || !filtered[idx]) return;

    const selectedOption = filtered[idx];
    this.value = selectedOption.id;
    this.textValue = selectedOption.cols ? selectedOption.cols.join('') : '';
    
    this.showPopup(false);
    this.valueChange.emit(selectedOption.id);

    if (this.clearOnSelect) {
      this.clear();
    }
    
    this.cdRef.detectChanges();
  }

  onBlur(event: FocusEvent) {
    if (!this._showPopup) return;

    // Check if focus moved to an element inside the popup or the component container
    const related = event.relatedTarget as HTMLElement;
    if (related && this.popup && this.popup.nativeElement.contains(related)) {
      return;
    }

    // Delay closing slightly so any pending mousedown/click handlers can finish
    setTimeout(() => {
      this.showPopup(false);
      this.cdRef.detectChanges();
    }, 150);
  }

  onDocClick(event: MouseEvent) {
    if (this.popup == null) return;
    
    const popupEl = this.popup.nativeElement;
    const targetEl = event.target as HTMLElement;

    if (this.preventDockClick) {
      this.preventDockClick = false;
      return;
    }

    // Do not close if click originated inside the popup or text input
    if (
      popupEl.contains(targetEl) || 
      (this.textinput && this.textinput.nativeElement.contains(targetEl))
    ) {
      return;
    }

    this.showPopup(false);
  }  

  onKeyUp(event) {
    this.showPopup(true);
    this.currentValue = event.target.value;
    // return
    if (event.keyCode === 13) {
      const select = this.selectedIndex > -1 ?
        this.filter(this.currentValue)[this.selectedIndex] : this.filter(this.currentValue)[0];
      if (!select && !this.textable) return;
      if (select) {
        this.value = select.id;
        this.textValue = select['name'];
        event.target.value = this.textValue;
        this.valueChange.emit(select.id);
      } else if (this.textable) {
        this.valueChange.emit(this.textValue);
      }
      this.showPopup(false);
      this.selectedIndex = 0;
      if (this.clearOnSelect) {
        this.clear();
        event.target.value = '';
      }
      // escape
    } else if (event.keyCode === 27) {
      this.showPopup(false);
      // arrow down
    } else if (event.keyCode === 40) {
      if (this.selectedIndex < this.filter(this.currentValue).length) {
        this.selectedIndex++;
      }
      this.adjustPopup();
      // arrow up
    } else if (event.keyCode === 38) {
      if (this.selectedIndex > 0 ) {
        this.selectedIndex--;
      }
      this.adjustPopup();
    }
    if (this.selectedIndex >= this.filter(this.currentValue).length) {
      this.selectedIndex = 0;
    }
  }

  adjustPopup() {
    if (this.popup == null || this.popup.nativeElement == null || this.listItems == null) return;
    const popupHeight = this.popup.nativeElement.offsetHeight;
    const itemHeight = this.listItems.nativeElement.offsetHeight;
    const scrollPos = this.popup.nativeElement.scrollTop;
    const itemPos = this.selectedIndex * itemHeight;
    if (itemPos - scrollPos < 0) {
      this.popup.nativeElement.scrollTop = itemPos;
    } else if (itemPos - scrollPos > popupHeight - itemHeight) {
      const pos = itemPos - popupHeight + itemHeight;
      const diff = pos % itemHeight;
      this.popup.nativeElement.scrollTop = pos + diff;
    }
  }

  filter(search: string) {
    if (!search) return this.displayOptions?.filter(notNull => notNull);
    const opts = 
      search 
      ? this.displayOptions?.filter(f => diacriticless(f?.cols.join('').toLowerCase())?.includes(diacriticless(search.toLocaleLowerCase())))
      : this.displayOptions

    this.itemsCount = opts?.length;
    return opts.filter(notNull => notNull);
  }

  clear() {
    if (this.value) this.valueChange.emit(null);
    this.value = null;
    this.textValue = '';
    this.showPopup(false);
  }

}
